import styled from 'styled-components'
import { Typography } from 'src/components'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
export const ContainerField = styled(FormControl)`
    width: 100%;
    height: 100%;
`

export const ErrorText = styled(Typography)`
    color: ${({ theme }) => theme.colors.danger};
    height: 15px;
    margin-left: 10px;
    font-family: inherit;
`

export const FieldFormt = styled(TextField)`
    backdrop-filter: blur(40.4444px);
    border-radius: 12px;
    color: ${({ theme }) => theme.colors.dark} !important;
    background: ${({ theme }) => theme.colors.white};
    border: transparent !important;
    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
        height: 100% !important;
        width: 100% !important;
    }
`
export const FieldFormtTextArea = styled.textarea`
    backdrop-filter: blur(40.4444px);
    border-radius: 12px;
    padding: 8px 10px 3px;
    height: 100px !important;
    background: ${({ theme }) => theme.colors.white};
    border: transparent !important;
    color: rgba(0, 0, 0, 0.6);
    font-family: inherit;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
        height: 100% !important;
        width: 100% !important;
    }
`
export const FieldFormSelect = styled(Select)`
    backdrop-filter: blur(40.4444px);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 18px !important;
    height: 50px !important;
    color: ${({ theme }) => theme.colors.dark} !important;
    background: ${({ theme }) => theme.colors.white};
    border: transparent !important;
    .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
        color: ${({ theme }) => theme.colors.dark} !important;
        width: 100% !important;
    }
`
export const FieldFormInputLabel = styled(InputLabel)`
    height: 55%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
`
export const SelectContent = styled(MenuItem)`
    height: 100%;
    width: 100%;
    text-decoration: none;
    padding: 12px 22px !important;
    color: ${({ theme }) => theme.colors.dark} !important;
    font-family: inherit !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 12px !important;
    line-height: 18px !important;
    .css-1poimk-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper {
        border-radius: 14px !important;
    }
    .css-r8u8y9 {
        padding: 0 !important;
    }
`
